import { put, takeLatest } from 'redux-saga/effects';

import { closeCreditCardModal } from '~/actions/billing.actions';
import { ActionKeys } from '~/actions/constants';

function* billingCloseCreditCardModal() {
  yield put(closeCreditCardModal());
}

export default [takeLatest(ActionKeys.USER_FETCH_SUCCESS, billingCloseCreditCardModal)];
